import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3054de64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-container" }
const _hoisted_2 = { class: "iframe-container" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], {
          class: "navigation-bar",
          title: "고객지원"
        }),
        _createElementVNode("div", _hoisted_2, [
          ($setup.parseComplete)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                src: $setup.chatUrl
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}